import React from 'react'
import { Line, Chart } from 'react-chartjs-2'
import ChartDataLabels from 'chartjs-plugin-datalabels';


const UtilityChart = (props) => {

  const { 
    years, 
    loan1Bills, 
    loan2Bills, 
    viewPayments, 
    index, 
    width, 
    smallBreakPoint,
    firstMonthPayment,
    escalationRate,
    loanTerm,
     } = props

  const dataPoints = 6;

  const calaculateMonthlyCostPerYear = (firstMonthPayment, escalationRate, loanTerm) => {
    const monthlyPayments = [firstMonthPayment];
    for (let i = 0; i < loanTerm - 1; i++) {
      const curMonthlyPayment = monthlyPayments[i];
      const newMonthlyPayment = curMonthlyPayment + (curMonthlyPayment * escalationRate);
      monthlyPayments.push(escalationRate > 0 ? newMonthlyPayment : firstMonthPayment);
    }
    return monthlyPayments;
  }

  const getChartDetails = (monthlyPayments, loanTerm) => {
    
    const increment = Math.floor(loanTerm / (dataPoints - 1));
    const data = [];

    for (let i = 0; i <= loanTerm; i+=increment) {
      data.push({
        x: i === 0 ? "Today" : `${i} Years`,
        y: i === 0 ? monthlyPayments[i] : monthlyPayments[i-1],
      })
    }
    return data;
  }
  const monthlyPayments = firstMonthPayment ? calaculateMonthlyCostPerYear(firstMonthPayment, +escalationRate, loanTerm) : loan1Bills;
  const data = getChartDetails(monthlyPayments, loanTerm);

  let dataset2 = {
    label: 'Solar',
    type: 'scatter',
    fill: '-1',
    showLine: true,
    datalabels: {
      display: false
    },
    data: data,
    lineTension: 0,
    borderWidth: 3,
    border: '500px',
    backgroundColor: [
      'rgba(139,176,244,.4)'
    ],

    pointBackgroundColor: [...Array(dataPoints).fill('rgba(65,126,238,1)')],
    borderColor: 'rgba(65,126,238,1)',
    pointBorderWidth: '200px',
    pointRotation: [...Array(dataPoints-1).fill(0), 90],
    pointStyle: [...Array(dataPoints-1).fill('circle'), 'triangle'],
    pointRadius: [6, ...Array(dataPoints-4).fill(0), 10],
    hoverRadius: [6, ...Array(dataPoints-4).fill(0), 10],
  }

  let dataset25 = {
    label: 'Solar1',
    type: 'scatter',
    fill: '-1',
    showLine: true,
    datalabels: {
      display: false
    },
    data: data,
    lineTension: 0,
    borderWidth: 3,
    border: '500px',
    backgroundColor: [
      'rgba(139,176,244,.4)'
    ],
    pointBackgroundColor: [...Array(dataPoints).fill('rgba(65,126,238,1)')],
    borderColor: 'rgba(65,126,238,1)',
    pointBorderWidth: '200px',

    pointRotation: [...Array(dataPoints).fill(0)],
    pointStyle: [...Array(dataPoints).fill('circle')],
    pointRadius: width > smallBreakPoint ? [...Array(dataPoints-1).fill(6), 10] : [...Array(dataPoints-1).fill(3), 5],
    hoverRadius: width > smallBreakPoint ? [...Array(dataPoints-1).fill(6), 10] : [...Array(dataPoints-1).fill(3), 5],
  }

  if (loan1Bills.length === 25) {
    dataset2 = dataset25
  }

  if (viewPayments === false) {
    dataset2 = {label: 'solar3'}
  }

  const getYearsVals = () => {
    const increment = Math.floor(loanTerm / (dataPoints - 1));
    const data = []
    for (let i = 0; i <= loanTerm; i+=increment) {
      data.push(i === 0 ? years[i] : years[i-1]);
    }
    return data;
  }

  const labels = data.map(d => d.x)
  const dataVals = getYearsVals();


  return (
    <div>
      <Line
        data={{
          labels: labels,
          datasets: [
            {
              label: '$',
              font: {
                size: 35,
                family: 'Lexend'
              },
              datalabels: {
                display: false
              },
              type: 'line',
              fill: false,
              data: dataVals,
              backgroundColor: [...Array(dataPoints).fill('rgba(248,47,43,1)')],
              borderColor: 'rgba(248,47,43,1)',
              pointBorderWidth: '150px',
              pointRotation: [...Array(dataPoints-1).fill(0), 53],
              pointStyle: [...Array(dataPoints-1).fill('circle'), 'triangle'],
              pointRadius: width > smallBreakPoint ? [...Array(dataPoints-1).fill(6), 10] : [...Array(dataPoints-1).fill(3), 5],
              hoverRadius: width > smallBreakPoint ? [...Array(dataPoints-1).fill(6), 10] : [...Array(dataPoints-1).fill(3), 5],
            }, dataset2
          ]
        }}
        options={{
          layout: {
            padding: {
              top: 35 
            }
          },
          tooltipTitleFontSize: 0,
          tooltips: {
            bodyFontFamily: 'Lexend',
            bodyFontStyle: '300',
            boxShadow: '0px 0px 8px 2px rgba(0,0,0,0.12)',
            titleFontSize: false,
            bodyFontSize: width > smallBreakPoint ? 45 : 15,
            displayColors: false,
            backgroundColor: 'white',
            footerFontColor: 'rgba(248,47,43,1)',
            hoverRadius: 6,
            callbacks: {
              title: function () { },
              label: function (context) {
                return '$' + Math.round(context.value)
              },
              labelTextColor: function (context) {
                if (context.datasetIndex === 0) {
                  return 'rgba(248,47,43,1)'
                } return 'rgba(65,126,238,1)'
              },
            },
            yAlign: 'bottom',
            xAlign: 'center',
          },
          title: {
            display: false,
            text: '',
            fontSize: 25,
            fontColor: '#000'

          },
          legend: {
            display: false,
            position: 'bottom',
            labels: { fontColor: '#000' }
          }, scales: {
            xAxes: [{
              gridLines: {
                drawOnChartArea: false,
                zeroLineColor: 'transparent',
                drawBorder: false,
              },
              ticks: {
                fontFamily: 'Lexend',
                fontSize: width > smallBreakPoint ? 18 : 10,
                fontStyle: '200',
                padding: 10,
                // display: false
              }
            }],
            yAxes: [{
              ticks: {
                fontFamily: 'Lexend',
                fontSize: width > smallBreakPoint ? 18 : 10,
                fontStyle: '200',
                padding: 10,
                beginAtZero: true,
                callback: function (value) {
                  return '$' + value;
                }
              },
              gridLines: {
                borderDash: [7, 6],
                color: 'rgba(209, 209, 209, 1)',
                drawBorder: false,
                // zeroLineColor: 'transparent',
               
              }
            }]
          }
        }} 
        height={width < smallBreakPoint ? 200 : 115}
      />
    </div>
  )

}




export default UtilityChart
